import { SAME_TAB_TARGET } from './constants'
import type { Link } from '@wix/public-schemas'
import { addAnchorsData, addRelToLinkProps } from './linkUtils'
import type { AnchorLinkData } from './linksDataTypes'
import type { PageLinkExtraData } from './pageLink'
import { resolvePageLinkHref } from './pageLink'
import { pickBy } from 'lodash'

export type AnchorLinkExtraData = Pick<
	PageLinkExtraData,
	| 'externalBaseUrl'
	| 'mainPageId'
	| 'disableStaticPagesUrlHierarchy'
	| 'pageIdToHierarchyRoute'
	| 'shouldEncodeUris'
	| 'pageIdToPageUriSEO'
>

export const handleAnchorLink = (linkData: AnchorLinkData, extraData: AnchorLinkExtraData): Link => {
	const { pageId, anchorName, rel, anchorDataId } = linkData

	// For SCROLL_TO_TOP and SCROLL_TO_BOTTOM, use the anchorDataId directly
	// because that's the actual DOM element ID
	const effectiveAnchorName = (anchorDataId === '#SCROLL_TO_TOP' || anchorDataId === '#SCROLL_TO_BOTTOM')
		? anchorDataId.replace('#', '')
		: anchorName

	const href = resolvePageLinkHref(pageId, extraData)
	const baseLinkProps = {
		href,
		target: SAME_TAB_TARGET,
	} as Link
	const linkPropsWithAnchorsData = addAnchorsData(baseLinkProps, effectiveAnchorName)
	const linkPropsWithRel = addRelToLinkProps(linkPropsWithAnchorsData, rel)

	return pickBy(linkPropsWithRel, (x) => x) as Link
}
